import { useState } from "react";
import { ArrowLeft, Loader2, MailCheck, Send } from "lucide-react";
import { Button } from "../ui/button";
import { errorText } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { EmailInput, FormError } from "./Fields";
import { StepTitle } from "./LoginShell";

// "First time with a password? / Forgot it?": one emailed single-use link (same answer whether or not the account exists).
export const ForgotPassword = ({ email, setEmail, onBack }) => {
  const { forgotPassword } = useAuth();
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await forgotPassword(email.trim());
      setSent(true);
    } catch (err) {
      setError(errorText(err, "Couldn't send the link. Please try again in a moment."));
    } finally {
      setBusy(false);
    }
  };

  const back = (
    <button type="button" data-testid="forgot-back-btn" onClick={onBack} className="inline-flex w-full items-center justify-center gap-1.5 text-sm text-[#5a554b] hover:text-[#1f1f24]">
      <ArrowLeft className="h-3.5 w-3.5" /> Back to sign in
    </button>
  );

  if (sent) {
    return (
      <div data-testid="forgot-sent" className="space-y-5">
        <span className="grid h-12 w-12 place-items-center rounded-2xl bg-[#ffc700]/30 text-[#1f1f24]">
          <MailCheck className="h-6 w-6" />
        </span>
        <StepTitle title="Check your inbox">
          If {email.trim()} can sign in to Duckify, a link to choose your password is on its way. It works once and
          expires in 60 minutes.
        </StepTitle>
        {back}
      </div>
    );
  }
  return (
    <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
      <StepTitle title="Choose a password">
        Enter your account email. We'll send you a link to choose a new password (or your first one).
      </StepTitle>
      <EmailInput value={email} onChange={setEmail} testid="forgot-email-input" />
      <FormError text={error} />
      <Button data-testid="forgot-submit-btn" type="submit" disabled={busy || !email.trim()} className="h-12 w-full rounded-full font-bold gap-2">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Email me a link
      </Button>
      {back}
    </form>
  );
};
